import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styled from 'styled-components';
import {
  Bubble,
  HintButton,
  HotelTrustYouCategoryList,
  HotelTrustYouGoodToKnowList,
  HotelRatingSquare,
} from '@lt/components';

import { pluralizeReviews } from '../../../../utils/pluralizeUtils';
import ShowReviewsButton from '../../containers/Reviews/ShowReviewsButton';
import { COMPONENT_ID } from '../../constants';

const baseCls = 'hotel-ratingblock';
const hintText =
  'Рейтинг рассчитывается на основании верифицированных отзывов изо всех источников в  интернете и является общепризнанной независимой оценкой репутации отеля в сети.';

const Rating = ({
  score,
  scoreDescription,
  count,
  category,
  goodToKnowList,
  double,
  text,
  showReviewsButton,
  isMobile,
}) => (
  <StyledContainer id={COMPONENT_ID.TRUST_YOU} isMobile={isMobile}>
    <div
      className={cn(`${baseCls}__title`, {
        [`${baseCls}__title--double`]: double,
      })}
    >
      <StyledHotelRatingSquare value={score} count={score} />
      <StyledScoreDescription>{scoreDescription}</StyledScoreDescription>
    </div>
    <StyledText>{text}</StyledText>
    <StyledDescription>
      {`Рейтинг формируется на основании ${count} ${pluralizeReviews(
        count,
      )} туристов, которые были в этом отеле сервисом TrustYou `}
      <Bubble text={hintText} inline>
        <HintButton />
      </Bubble>
    </StyledDescription>
    <StyledHotelTrustYouCategoryList
      data={category}
      columns={double ? 2 : 1}
      smallMargin={!double || isMobile}
    />
    {double && (
      <>
        <HotelTrustYouGoodToKnowList data={goodToKnowList} />
        {showReviewsButton && <ShowReviewsButton />}
        <StyledCredentials>Verified Reviews TrustYou</StyledCredentials>
      </>
    )}
  </StyledContainer>
);

Rating.defaultProps = {
  double: false,
  category: [],
  goodToKnowList: [],
  showReviewsButton: false,
};

Rating.propTypes = {
  double: PropTypes.bool,
  score: PropTypes.number.isRequired,
  scoreDescription: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  category: PropTypes.arrayOf(
    PropTypes.shape({
      category_name: PropTypes.string.isRequired,
      category_id: PropTypes.string.isRequired,
      score: PropTypes.number.isRequired,
    }).isRequired,
  ),
  goodToKnowList: PropTypes.arrayOf(
    PropTypes.shape({
      sentiment: PropTypes.oneOf(['neg', 'pos', 'neu']),
      category_id: PropTypes.string.isRequired,
      category_name: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  ),
  text: PropTypes.string.isRequired,
  showReviewsButton: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
};

const StyledText = styled.p`
  margin-bottom: 5px;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledHotelTrustYouCategoryList = styled(HotelTrustYouCategoryList)`
  margin-bottom: ${(props) => (props.smallMargin ? '10px' : '20px')};
`;

const StyledDescription = styled.p`
  margin-bottom: 20px;
  color: ${(props) => props.theme.colors.greyLight};
`;

const StyledCredentials = styled.p`
  text-align: right;
  color: ${(props) => props.theme.colors.greyLight};
`;

const StyledContainer = styled.div`
  ${(props) => `
    font-size: ${props.isMobile ? '13' : '14'}px;

    ${HotelTrustYouGoodToKnowList.Item},
    ${StyledHotelTrustYouCategoryList.Title} {
      font-size: ${props.isMobile ? '13' : '14'}px;
    }

    ${StyledDescription},
    ${StyledHotelTrustYouCategoryList.Description},
    ${StyledCredentials} {
      font-size: ${props.isMobile ? '11' : '12'}px;
    }
  `}
`;

const StyledScoreDescription = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

const StyledHotelRatingSquare = styled(HotelRatingSquare)`
  margin-right: 4px;
`;

export default Rating;
